// Communication Management copy of ParentNotificationSection.
// Identical to ../../Parent Notifications/ParentNotificationSection.jsx except it
// renders the CommParentNotificationModal (restyled, single-row filters) and a
// certificate-style table: Branch / Class / Section are filter dropdowns
// (default = all selected) instead of table columns.
// Separate file so the standalone /Parent_Notification module is unaffected.

import React, { Component } from 'react';
import MultiSelect from "react-multi-select-component";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import moment from 'moment';
import CommParentNotificationModal from './CommParentNotificationModal';
import LongDiscriptionModal from '../../Parent Notifications/LongDiscriptionModal';
import CardLessDataTableWithOutSearch from '../../datatables/CardLessDataTableWithOutSearch';
import NotificationPageShimmer from '../../preloader/NotificationShimmer';
import '../../Parent Notifications/_parentNotification.scss';
import './_commParentNotification.scss';
import { canView } from "../../../../utils/modulePermissions";
import {
    attachModuleGuard,
    AccessDeniedModal,
    AccessDeniedCard,
} from "../../../../utils/moduleGuard";
import {
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    getAuthorizedSubjectIds,
    filterByAuthorizedIds
} from "../../../utils/authHelper";
import { scopeBranches, onBranchScopeChange } from "../../../../utils/branchScope";

// /communication-management/* → "communication_management" (see MODULE_ROUTES in
// moduleAccessGuard).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
const COMMUNICATION_MODULE = ["communication_management"];

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        stream_id
        section_name
        class_id
        subjects {
          subject_id
          subject_name
        }
      }
    }
  }
`;

const GET_CLASSES = gql`
  query getExamClasses($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

const GET_STREAMS = gql`
  query getStreams {
    getStreams {
      id
      stream
      classes
    }
  }
`;
const GET_STUDENT_DETAILS = gql`
query($institute_id:Int){
    getNewEducationalStudents(institute_id: $institute_id) {
        roll_no
        student_name
        class_id
        class_name
        exam_id
        exam_name
        branch_id
        branch_name
        section_id
        section_name
        parent_name
        parent_mobile
        parent_password
        student_id
      }
}
`
const GET_PARENTS_CUSTOM_NOTIFICATION = gql`
query($institution_id:Int $branch_ids: [String]){
    getParentsCustomNotification(institution_id: $institution_id, branch_ids: $branch_ids) {
        title
        branch_ids
        section_ids
        notification_sent_timestamp
        exam_ids
        class_ids
        long_description
      }
}
`

class CommParentNotificationSection extends Component {
    constructor() {
        super();
        this.state = {
            modalShow: false,
            viewDetailModal: false,
            selectedDiscription: "",
            // Filter selections (default = all selected, populated once globals load)
            filtersInit: false,
            selectedBranches: [],
            selectedClasses: [],
            selectedSections: [],
            accessDeniedShow: false,
        }

        this.guard = attachModuleGuard(this, COMMUNICATION_MODULE);
    }

    // Default every filter to "all selected" as soon as globals are available
    // (covers both the freshly-loaded and the already-cached case).
    componentDidMount() {
        this.maybeInitFilters();
        // Branch comes from the header (NavbarOne). Re-running the init rebuilds the
        // Branch/Class/Section defaults from the new scope.
        this.offBranchScope = onBranchScopeChange(() =>
            this.setState({ filtersInit: false }, this.maybeInitFilters)
        );
    }

    componentDidUpdate() {
        this.maybeInitFilters();
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    maybeInitFilters = () => {
        const branchesData = (this.props.getBranchesQuery && this.props.getBranchesQuery.getBranches) || [];
        const classesData = (this.props.getClassesQuery && this.props.getClassesQuery.getExamClasses) || [];

        if (!this.state.filtersInit && (branchesData.length > 0 || classesData.length > 0)) {
            const authorizedClassIds = getAuthorizedClassIds();
            const authorizedSectionIds = getAuthorizedSectionIds();

            // The header's branch selection IS this page's branch filter, and it
            // never widens past the branches the user is authorized for.
            const branches = scopeBranches(branchesData);

            let sections = branches.flatMap((b) =>
                (b.sections || []).map((s) => ({ ...s, branch_id: b.id }))
            );
            if (authorizedSectionIds.length || authorizedClassIds.length) {
                sections = filterByAuthorizedIds(
                    filterByAuthorizedIds(sections, authorizedSectionIds, "id"),
                    authorizedClassIds,
                    "class_id"
                );
            }

            const classes = filterByAuthorizedIds(classesData, authorizedClassIds, "id");
            const streamsData = (this.props.getStreamsQuery && this.props.getStreamsQuery.getStreams) || [];
            const streamOptions = streamsData.map((st) => ({ label: st.stream, value: String(st.id) }));

            this.setState({
                filtersInit: true,
                selectedBranches: branches.map((b) => ({ label: b.branch_name, value: String(b.id) })),
                selectedClasses: classes.map((c) => ({ label: c.class, value: String(c.id) })),
                selectedSections: sections.map((s) => ({ label: s.section_name, value: String(s.id) })),
                selectedStreams: streamOptions,
            });
        }
    }

    // "Send Notification" — opens CommParentNotificationModal, which owns the send
    // mutation. Gating the opener stops the write; the button stays visible and
    // clickable. The modal re-checks at submit.
    sendNotifyBtn = () => {
        if (!this.guard.requireEdit()) return;

        this.setState({ modalShow: true })
    }

    articlecolumns = [
        {
            dataField: "sno",
            text: "S.No",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "title",
            text: "Notification",
            sort: true,
            formatter: (cell) => (
                <span className="cpn-title-text" title={cell || ""}>{cell || "—"}</span>
            ),
        },
        {
            dataField: "branch",
            text: "Branch",
            formatter: (cell) => <span className="cpn-meta cpn-bcs" title={cell || ""}>{cell || "—"}</span>,
        },
        {
            dataField: "class",
            text: "Class",
            formatter: (cell) => <span className="cpn-meta cpn-bcs" title={cell || ""}>{cell || "—"}</span>,
        },
        {
            dataField: "section",
            text: "Section",
            formatter: (cell) => <span className="cpn-meta cpn-bcs" title={cell || ""}>{cell || "—"}</span>,
        },
        {
            dataField: "date",
            text: "Date",
            sort: true,
            formatter: (cell) => <span className="cpn-meta"><i className="fal fa-calendar-alt" />{cell}</span>,
        },
        {
            dataField: "time",
            text: "Time",
            sort: true,
            formatter: (cell) => <span className="cpn-meta"><i className="fal fa-clock" />{cell}</span>,
        },
        {
            dataField: "View Details",
            text: "Action",
            classes: "cpn-sticky-col",
            headerClasses: "cpn-sticky-col",
            formatter: this.performanceFunc.bind(this),
        },
    ];

    tableUserData() {
        let notifyParent = (this.props.getParentsCustomNotification && this.props.getParentsCustomNotification.getParentsCustomNotification) || [];

        const branchesData = (this.props.getBranchesQuery && this.props.getBranchesQuery.getBranches) || [];
        const classesData = (this.props.getClassesQuery && this.props.getClassesQuery.getExamClasses) || [];

        const bMap = {}, cMap = {}, sMap = {};
        branchesData.forEach((b) => { bMap[String(b.id)] = b.branch_name; });
        classesData.forEach((c) => { cMap[String(c.id)] = c.class; });
        branchesData.flatMap((b) => b.sections || []).forEach((s) => { sMap[String(s.id)] = s.section_name; });
        const namesFrom = (ids, map) => ids.map((id) => map[id]).filter(Boolean).join(", ") || "All";

        const selBArr = this.state.selectedBranches.map((o) => String(o.value));
        const selCArr = this.state.selectedClasses.map((o) => String(o.value));
        const selSArr = this.state.selectedSections.map((o) => String(o.value));
        const selB = new Set(selBArr);
        const selC = new Set(selCArr);
        const selS = new Set(selSArr);
        // Constrain a dimension only when the user has narrowed it to a proper
        // subset (not "all" and not empty). Avoids the filtersInit timing gate.
        const conB = selBArr.length > 0 && selBArr.length < Object.keys(bMap).length;
        const conC = selCArr.length > 0 && selCArr.length < Object.keys(cMap).length;
        const conS = selSArr.length > 0 && selSArr.length < Object.keys(sMap).length;

        const newArray = [];

        notifyParent.forEach((mapdata) => {
            const recB = (mapdata.branch_ids || "").split(",").map((s) => s.trim()).filter(Boolean);
            const recC = (mapdata.class_ids || "").split(",").map((s) => s.trim()).filter(Boolean);
            const recS = (mapdata.section_ids || "").split(",").map((s) => s.trim()).filter(Boolean);

            const bMatch = !conB || recB.length === 0 || recB.some((id) => selB.has(id));
            const cMatch = !conC || recC.length === 0 || recC.some((id) => selC.has(id));
            const sMatch = !conS || recS.length === 0 || recS.some((id) => selS.has(id));
            if (!(bMatch && cMatch && sMatch)) return;

            newArray.push({
                title: mapdata.title,
                longdiscription: mapdata.long_description,
                branch: namesFrom(recB, bMap),
                class: namesFrom(recC, cMap),
                section: namesFrom(recS, sMap),
                date: moment.unix(mapdata.notification_sent_timestamp).format("DD/MM/YYYY"),
                time: moment.unix(mapdata.notification_sent_timestamp).format("LT"),
            });
        })
        return newArray;
    }

    performanceFunc(val, row) {
        return (
            <button
                className="cpn-view-btn"
                onClick={() => this.setState({ viewDetailModal: true, selectedDiscription: row.longdiscription })}
            >
                <i className="fal fa-eye" /> View
            </button>
        )
    }

    render() {
        // is_view === 0 → the notification data is never rendered, and the three queries
        // below are skipped so nothing is fetched. This MUST stay above the prop reads
        // that follow.
        if (!this.guard.canView()) {
            return <AccessDeniedCard />;
        }

        const branchesQuery = this.props.getBranchesQuery || {};
        const classesQuery = this.props.getClassesQuery || {};
        const getParentsCustomNotification = this.props.getParentsCustomNotification || {};

        const loading1 = branchesQuery.loading || classesQuery.loading;
        const error1 = branchesQuery.error || classesQuery.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        const getNewEducationalStudents = this.props.getNewEducationalStudents || {};
        const loading2 = getNewEducationalStudents.loading;
        const error2 = getNewEducationalStudents.error

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        const loading3 = getParentsCustomNotification.loading;
        const error3 = getParentsCustomNotification.error
        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        const branchesData = branchesQuery.getBranches || [];
        const classesData = classesQuery.getExamClasses || [];

        const authorizedClassIds = getAuthorizedClassIds();
        const authorizedSectionIds = getAuthorizedSectionIds();

        // The header's branch selection IS this page's branch filter.
        const allowedBranches = scopeBranches(branchesData);

        let allowedSections = allowedBranches.flatMap((b) =>
            (b.sections || []).map((s) => ({ ...s, branch_id: b.id }))
        );
        if (authorizedSectionIds.length || authorizedClassIds.length) {
            allowedSections = filterByAuthorizedIds(
                filterByAuthorizedIds(allowedSections, authorizedSectionIds, "id"),
                authorizedClassIds,
                "class_id"
            );
        }

        const allowedClasses = filterByAuthorizedIds(classesData, authorizedClassIds, "id");
        const streamsData = (this.props.getStreamsQuery && this.props.getStreamsQuery.getStreams) || [];

        const selectedClassIds = (this.state.selectedClasses || []).map((c) => String(c.value));
        const selectedBranchIds = (this.state.selectedBranches || []).map((b) => String(b.value));

        let relevantSections = allowedSections;
        if (selectedBranchIds.length > 0 && selectedBranchIds.length < allowedBranches.length) {
            relevantSections = relevantSections.filter((s) => selectedBranchIds.includes(String(s.branch_id)));
        }
        if (selectedClassIds.length > 0 && selectedClassIds.length < allowedClasses.length) {
            relevantSections = relevantSections.filter((s) => selectedClassIds.includes(String(s.class_id)));
        }

        const availableStreamIds = new Set(
            relevantSections.filter((s) => s.stream_id != null).map((s) => String(s.stream_id))
        );

        let streamOptions = streamsData.map((st) => ({ label: st.stream, value: String(st.id) }));
        if (availableStreamIds.size > 0) {
            streamOptions = streamOptions.filter((opt) => availableStreamIds.has(opt.value));
        }

        const selectedStreamIds = (this.state.selectedStreams || []).map((s) => String(s.value));
        if (selectedStreamIds.length > 0 && selectedStreamIds.length < streamOptions.length) {
            relevantSections = relevantSections.filter((s) => !s.stream_id || selectedStreamIds.includes(String(s.stream_id)));
        }

        const classOptions = allowedClasses.map((c) => ({ label: c.class, value: String(c.id) }));
        const sectionOptions = relevantSections.map((s) => ({ label: s.section_name, value: String(s.id) }));

        const rows = (loading1 || loading3) ? [] : this.tableUserData();

        return (
            <React.Fragment>
                {
                    loading1 || loading2 || loading3 ?
                        (
                            <NotificationPageShimmer rows={6} cols={8} />
                        ) : (
                            <div className="pn-page comm-pn-page">
                                <div className="pn-header">
                                    <div className="pn-header-left">
                                        <i className="fas fa-bell pn-header-icon" />
                                        <div>
                                            <h5 className="pn-title">Parent Notifications</h5>
                                            <small className="pn-subtitle">Notify students' parents and review sent notifications</small>
                                        </div>
                                    </div>
                                    <button className="pn-send-btn" onClick={this.sendNotifyBtn}>
                                        <i className="fas fa-paper-plane" /> Send Notification
                                    </button>
                                </div>

                                <div className="pn-table-card">
                                    {/* Filter header (certificate-style) */}
                                    <div className="comm-filter-head">
                                        <div className="comm-filter-title">
                                            <span className="comm-filter-icon"><i className="fal fa-sliders-h" /></span>
                                            Filters
                                        </div>
                                        <span className="pn-count">{rows.length} {rows.length === 1 ? "record" : "records"}</span>
                                    </div>

                                    {/* Class / Section multi-select filters (default all). No Branch
                                        filter — the header's branch selection scopes this page. */}
                                    <div className="comm-filter-bar">
                                        <div className="comm-filter-field">
                                            <label><i className="fal fa-layer-group mr-1" /> Class</label>
                                            <MultiSelect
                                                options={classOptions}
                                                value={this.state.selectedClasses}
                                                onChange={(v) => this.setState({ selectedClasses: v })}
                                                labelledBy="Class"
                                                overrideStrings={{ allItemsAreSelected: "All Classes", selectSomeItems: "Select Class" }}
                                            />
                                        </div>
                                        {streamOptions.length > 0 && (
                                             <div className="comm-filter-field">
                                                 <label><i className="fal fa-water mr-1" /> Stream</label>
                                                 <MultiSelect
                                                     options={streamOptions}
                                                     value={this.state.selectedStreams || streamOptions}
                                                     onChange={(v) => this.setState({ selectedStreams: v })}
                                                     labelledBy="Stream"
                                                     overrideStrings={{ allItemsAreSelected: "All Streams", selectSomeItems: "Select Stream" }}
                                                 />
                                             </div>
                                         )}
                                        <div className="comm-filter-field">
                                            <label><i className="fal fa-users mr-1" /> Section</label>
                                            <MultiSelect
                                                options={sectionOptions}
                                                value={this.state.selectedSections}
                                                onChange={(v) => this.setState({ selectedSections: v })}
                                                labelledBy="Section"
                                                overrideStrings={{ allItemsAreSelected: "All Sections", selectSomeItems: "Select Section" }}
                                            />
                                        </div>
                                    </div>

                                    {/* Table */}
                                    <div className="comm-table-wrap">
                                        <CardLessDataTableWithOutSearch
                                            parentData={rows}
                                            particlecolumns={this.articlecolumns}
                                        />
                                    </div>
                                </div>

                                {this.state.modalShow && (
                                    <CommParentNotificationModal
                                        stateData={this.state}
                                        show={this.state.modalShow}
                                        onHide={() => this.setState({ modalShow: false })}
                                        getNewEducationalStudents={getNewEducationalStudents.getNewEducationalStudents}
                                        refetchNotifications={getParentsCustomNotification.refetch}
                                    />
                                )}

                                <LongDiscriptionModal
                                    stateData={this.state}
                                    show={this.state.viewDetailModal}
                                    onHide={() => this.setState({ viewDetailModal: false })}
                                />
                            </div>
                        )
                }

                {/* Shown instead of opening the send-notification modal when is_edit is
                    missing. This module has no delete surface. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />
            </React.Fragment>
        )
    }
}
// skip on every READ: is_view === 0 → the module's data is not fetched at all, so it
// can't sit in the Apollo cache behind the Access Denied card.
const skipUnlessViewable = () => !canView(COMMUNICATION_MODULE);

export default compose(
    graphql(GET_BRANCHES, {
        options: props => ({
            variables: { institution_id: parseInt(Cookies.get("institutionid")) }
        }), skip: skipUnlessViewable, name: "getBranchesQuery"
    }),
    graphql(GET_CLASSES, {
        options: props => ({
            variables: { id: 1 }
        }), skip: skipUnlessViewable, name: "getClassesQuery"
    }),
    graphql(GET_STREAMS, { skip: skipUnlessViewable, name: "getStreamsQuery" }),
    graphql(GET_STUDENT_DETAILS, {
        options: (props) => ({
            variables: { institute_id: parseInt(Cookies.get("institutionid")) },
        }),
        skip: skipUnlessViewable,
        name: "getNewEducationalStudents",
    }),
    graphql(GET_PARENTS_CUSTOM_NOTIFICATION, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                branch_ids: Cookies.get("branch_id").toString("")
            },
        }),
        skip: skipUnlessViewable,
        name: "getParentsCustomNotification",
    })
)(CommParentNotificationSection);
